import { Component, OnInit } from "@angular/core";
import { utils } from "protractor";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { ReadCount } from "src/app/models/readCount";
import { UsrCred } from "src/app/models/usrcred";
import { VproService } from "src/app/service/vpro/vpro.service";
import { sortBy } from 'underscore';
import moment from 'moment';
import { NgxSpinnerService } from "ngx-spinner";
//import { Chart } from 'chart.js';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-addashboard',
  templateUrl: './addashboard.component.html',
  styleUrls: ['./addashboard.component.css']
})
export class AddashboardComponent implements OnInit {

  public checkRoleType: (type: any, input: any) => boolean =
    this.utils.checkRoleType;
  public userType: any = Utils.USER_TYPE;
  appcount = new ReadCount();
  // tslint:disable-next-line:no-inferrable-types
  submitted: boolean = false;
  dcred = new DashCred();
  MainCtrl = "first";
  rcounts: any;
  dcounts: any;
  apnames: any;
  chkdet: any;
  user = new UsrCred();
  data: number;
  currentDate = Utils.maxDate;

  users = [];
  fdeskusers = [];

  name1: any;
  name2: any;

  AppointmentStatus = Utils.APPOINTMENT_STATUS;
  noAppointments: boolean = false;
  Appointments: any;
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  apptlen: any;

  acheckin: any[];
  isCheckInLoading: boolean;
  checkin_count: number;
  adm_checkin_count: number;
  cma: any;
  lma: any;
  cme: any;
  lme: any;
  payloadInvoce: any;
  totalamount: number;
  payloadInvocee: any;
  lmtotalamount: number;
  cmtotalamount: any;
  lmaptonline: any;
  cmaptonline: any;

  a_dashboardvalues: any;

  public chart: any;
  public chart1: any;



  constructor(private service: VproService, private utils: Utils, private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
    this.spinner.show();
    // console.log("localStorage", localStorage);

    this.name1 = localStorage.getItem("first_name");
    this.name2 = localStorage.getItem("last_name");

    this.data = JSON.parse(localStorage.getItem("LogUsrTyp"));
    //console.log("From Login in admin dashboard", this.data);

    this.getdashboardvalues();
    this.finddrs();
    this.findfrontdesk();
    this.apptcount();
    this.chkincount_adm();
    // this.createChart();
    //this.createChart1();
    this.appt_data();


    // if (this.utils.checkRoleType(Utils.USER_TYPE.admin, this.data)) {
    //   document.getElementById("shoApp").style.display = "none";
    //    document.getElementById("shoPat").style.display = 'none'
    // } else if (this.utils.checkRoleType(Utils.USER_TYPE.physician, this.data)) {
    //   document.getElementById("shoApp").style.display = "none";
    //   document.getElementById("shoPat").style.display = "block";
    // } else if (
    //   this.utils.checkRoleType(Utils.USER_TYPE.front_desk, this.data)
    // ) {
    //   document.getElementById("shoApp").style.display = "block";
    //   document.getElementById("shoPat").style.display = "none";
    // }

    this.getCheckedInPats(localStorage.getItem("LogUsr"));

    this.service
      .getApcount(this.dcred)
      .subscribe((data) => (this.rcounts = data));

    this.service
      .getDocCount(this.dcred)
      .subscribe((data) => (this.dcounts = data));

    // this.service.getApNames(this.dcred)
    // .subscribe(data => this.apnames = data);
  }


  // createChart() {

  //   this.chart = new Chart("MyChart", {
  //     type: 'bar', //this denotes tha type of chart

  //     data: {// values on X-Axis
  //       labels: ['2022-12', '2023-01', '2023-02', '2023-03', '2023-04', '2023-05'],
  //       datasets: [
  //         {
  //           label: "Online",
  //           data: ['467', '576', '572', '79', '92', '574'],
  //           backgroundColor: 'blue'
  //         },
  //         {
  //           label: "Inperson",
  //           data: ['542', '542', '536', '327', '17', '541'],
  //           backgroundColor: 'limegreen'
  //         }
  //       ]
  //     },
  //     options: {
  //       aspectRatio: 2.5
  //     }

  //   });
  // }

  // createChart1() {

  //   this.chart1 = new Chart("MyChart1", {
  //     type: 'line', //this denotes tha type of chart

  //     data: {// values on X-Axis
  //       labels: ['2022-12', '2023-01', '2023-02', '2023-03', '2023-04', '2023-05'],
  //       datasets: [
  //         {
  //           label: "Revenue",
  //           data: ['46220', '57120', '11570', '79210', '92000', '95075'],
  //           backgroundColor: 'blue'
  //         },

  //       ]
  //     },
  //     options: {
  //       aspectRatio: 2.5
  //     }

  //   });
  // }



  getCheckedInPats(usereid: string) {
    try {
      this.service.getCheckedInPats().subscribe(
        (res) => {
          this.chkdet = res;
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
  getApcount() {
    try {
      this.service.getApcount(this.dcred).subscribe(
        (res) => {
          this.rcounts = res;
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  getDocCount() {
    try {
      this.service.getDocCount(this.dcred).subscribe(
        (res) => {
          this.dcounts = res;
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  // getApNames() {
  //   try {
  //     this.service.getApNames(this.dcred).subscribe(res => {
  //       this.apnames = res;
  //     }, error => {
  //       console.log(error);
  //     });
  //   } catch (excep) {
  //     console.log(excep);
  //   }
  // }




  getdashboardvalues() {

    try {

      let orgcode = localStorage.getItem("orgcode");
      let date = this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day;


      this.service.admindashboardvalues({ org_code: orgcode, date: date }).subscribe(
        (res) => {
          let lmtotal = 0;
          let lmfeetotal = 0;
          let cmtotal = 0;
          let cmfeetotal = 0;
          // this.payloadInvoce = res['THIS_MONTH_EARNING'];
          // this.payloadInvocee = res['LAST_MONTH_EARNING'];
          // this.cmaptonline = res['THIS_MONTH_APPOINTMENT_ONLINE'];
          // this.lmaptonline = res['LAST_MONTH_APPOINTMENT'];

          this.a_dashboardvalues = res;

          console.log("getdashboardvalues", this.a_dashboardvalues);
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    } catch (excep) {
      console.log(excep);
      this.spinner.hide();
    }
  }


  finddrs() {

    this.users = [];

    let data = {
      name: null,
      org_code: localStorage.getItem("orgcode")
    }
    //console.log("DATAAA", data);

    this.service.fetchPhysicians(data).subscribe(
      (response) => {
        //this.spinner.hide();

        console.log("this.response", response);
        if (response && response['result'] && response['result'].length > 0) {
          this.users = response['result'];
          this.users = sortBy(this.users, 'first_name'); // Data Sorter via underscore.js

          console.log("this.users", this.users);
        }
      },
      (error) => {
        console.log(error);
        //this.spinner.hide();
      })

  }


  findfrontdesk() {

    this.fdeskusers = [];

    let data = {
      name: null,
      org_code: localStorage.getItem("orgcode")
    }
    // console.log("DATAAA", data);
    this.service.searchFrontDesk(data).subscribe(
      (response) => {
        //this.spinner.hide();

        //console.log("this.response", response);
        if (response && response.length > 0) {
          this.fdeskusers = response;
          this.fdeskusers = sortBy(this.fdeskusers, 'first_name'); // Data Sorter via underscore.js

          console.log("this.fdeskusers", this.fdeskusers);
        }
      },
      (error) => {
        console.log(error);
        //this.spinner.hide();
      })




  }

  apptcount() {

    let datas = {
      org_code: localStorage.getItem('orgcode'),
      status: [this.AppointmentStatus.APPROVAL_REQUESTED],
      from: moment().format("YYYY-M-DD"),
      to: moment().format("YYYY-M-DD"),

    }

    //  console.log("datasdatasdatas", datas);




    this.service.displayAppoint(datas, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      // this.spinner.hide();
      this.Appointments = res['data'];
      // this.Appointments = sortBy(this.Appointmentss, 'apdate'); // Data Sorter via underscore.js
      this.apptlen = this.Appointments.length;
      console.log("APPOINTTAPPOINTT", this.apptlen);
      this.collectionSize = res['totalCount'];
      if (this.Appointments && this.Appointments.length) {
        // this.Appointments = sortBy(this.Appointments, 'aptime'); // Data Sorter via underscore.js
        // this.Appointments = sortBy(this.Appointments, 'apdate'); // Data Sorter via underscore.js
        this.noAppointments = false;
      }
      else {
        this.noAppointments = true;
        this.page = 1;
        this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
      }
    }, err => {
      //this.spinner.hide();
      console.log(err);
    })
  }

  chkincount_adm() {

    //console.log("console the values", values)

    try {

      this.isCheckInLoading = true;
      let data = {

        org_code: localStorage.getItem('orgcode'),
        apttype: Utils.OFFLINE_APPOINTMENTS,
        apdate: moment().format("YYYY-M-DD"),


      }
      // let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

      // if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
      //   data["drid"] = parseInt(localStorage.getItem("uid"));
      // }

      //console.log("chkincount_adm", data);

      this.service.displayAppoint(data).subscribe(
        (appointments: any[]) => {
          console.log("chkincount_adm", appointments.length);
          this.acheckin = appointments;
          this.adm_checkin_count = appointments.length;

          // if (data.doc_name) {
          //   this.acheckin = this.acheckin.filter(docname =>

          //     docname.physician_first_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     || docname.physician_last_name.toLowerCase().includes(data.doc_name.toLowerCase())
          //     //   docname.physician_first_name == input.doc_name

          //     || docname.physician_first_name.toString().concat(" ", docname.physician_last_name.toString()).toLowerCase().includes(data.doc_name.toLowerCase()))


          // }
          // this.acheckin = this.acheckin.filter(list => list.dob != null)
          //this.acheckin = sortBy(this.acheckin, 'aptime'); // Data Sorter via underscore.js
          // this.acheckin = sortBy(this.acheckin, 'apdate'); // Data Sorter via underscore.js




          // let norecmsg = (this.acheckin && this.acheckin.length == 0)

          //   ? this.innerHtml = "<h3 align='center'>No appointments</h3>" : this.innerHtml = "";

          // this.isCheckInLoading = false;
        },
        (error) => {
          console.log(error);
        }
      );

    } catch (excep) {
      console.log(excep);
    }
  }

  appt_data() {

    let orgcode = localStorage.getItem("orgcode");


    this.service.admindashboardvalues({ org_code: orgcode }).subscribe(
      (res) => {


        console.log("CHART DATA CONSOLIDATED:", res);

        let inperson_appt = res['LAST_SIX_MONTH_INPERSON_APPOINTMENT'];
        let online_appt = res['LAST_SIX_MONTH_ONLINE_APPOINTMENT'];

        let inperson_revenue = res['LAST_SIX_MONTH_INPERSON_FEE'];
        let online_revenue = res['LAST_SIX_MONTH_ONLINE_FEE'];




        let dt_appt_array: any[] = [];
        let value_inperson_appt: any[] = [];
        let value_online_appt: any[] = [];

        let dt_revenue_array: any[] = [];
        let value_inperson_revenue: any[] = [];
        let value_online_revenue: any[] = [];

        //console.log(date.toDateString());
        for (var i = 0; i < inperson_appt.length; i++) {


          if (inperson_appt[i].appointment_to_month == null)
            inperson_appt[i].appointment_to_month = 0;



          value_inperson_appt.push(inperson_appt[i].appointment_to_month);

          // let dt = new Date(inperson_appt[i].appointment_to_month);

          // let inperson_dt;

          // var month = dt.toLocaleString('default', { month: 'short' });
          // inperson_dt = month + '-' + dt.getFullYear()

          dt_appt_array.push(inperson_appt[i].ym_text);
        }


        for (var j = 0; j < online_appt.length; j++) {

          if (online_appt[j].appointment_to_month == null)
            online_appt[j].appointment_to_month = 0;


          value_online_appt.push(online_appt[j].appointment_to_month);

          // let dt = new Date(online_appt[j].appointment_to_month);
          // let online_dt;
          // var month = dt.toLocaleString('default', { month: 'short' });
          // online_dt = month + '-' + dt.getFullYear()

          // dt_revenue_array.push(online_dt);
        }

        for (var k = 0; k < inperson_revenue.length; k++) {

          if (inperson_revenue[k].inperson_cost == null)
            inperson_revenue[k].inperson_cost = 0;


          value_inperson_revenue.push(inperson_revenue[k].inperson_cost);

          // let dt = new Date(inperson_appt[i].appointment_to_month);

          // let inperson_dt;

          // var month = dt.toLocaleString('default', { month: 'short' });
          // inperson_dt = month + '-' + dt.getFullYear()

          dt_revenue_array.push(inperson_revenue[k].ym_text);
        }

        for (var l = 0; l < online_revenue.length; l++) {

          if (online_revenue[l].online_fee == null)
            online_revenue[l].online_fee = 0;


          value_online_revenue.push(online_revenue[l].online_fee);

          // let dt = new Date(online_appt[j].appointment_to_month);
          // let online_dt;
          // var month = dt.toLocaleString('default', { month: 'short' });
          // online_dt = month + '-' + dt.getFullYear()

          // dt_revenue_array.push(online_dt);
        }




        console.log("dt_appt_array", dt_appt_array);
        console.log("value_online_appt", value_online_appt);
        console.log("value_inperson_appt", value_inperson_appt);


        console.log("dt_revenue_array", dt_revenue_array);
        console.log("value_online_revenue", value_online_revenue);
        console.log("value_inperson_revenue", value_inperson_revenue);


        //console.log("ONLINE DATA", value_online_array);
        // console.log("ONLINE LABEL", dt_revenue_array);

        //BAR CHART for Appointments

        this.chart = new Chart("MyChart", {
          type: 'bar', //this denotes tha type of chart

          data: {// values on X-Axis
            labels: dt_appt_array, //appointments date value - X Axis
            datasets: [
              {
                label: "Online",
                data: value_online_appt, // Online appointments count
                backgroundColor: '#386CAF'
              },
              {
                label: "Inperson",
                data: value_inperson_appt, // offline appointments count
                backgroundColor: '#4FC3F7'
              }
            ]
          },
          options: {
            aspectRatio: 2.5
          }

        });


        // line chart for  Revenue

        this.chart1 = new Chart("MyChart1", {
          type: 'line', //this denotes tha type of chart

          data: {// values on X-Axis
            labels: dt_revenue_array,
            datasets: [
              {
                label: "Online",
                data: value_online_revenue,
                backgroundColor: '#386CAF'
              },
              {
                label: "Inperson",
                data: value_inperson_revenue,
                backgroundColor: '#4FC3F7'
              }


            ]
          },
          options: {
            aspectRatio: 2.5
          }

        });


      },
      (error) => {
        console.log(error);
        this.spinner.hide();
      }
    );


  }

}
